import { Alert, Grid, InputLabel, Stack } from '@mui/material';
import { Form, Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';
import CustomButton from '../../elements/CustomButton';
import Modal from '../../elements/Modal';
import TextInput from '../../elements/TextInput';
import ExecutionScopeForm from '../../elements/common/execution/ExecutionScopeForm';
import ExecutionScopeAlert from '../../elements/common/execution/ExecutionScopeAlert';

const AddTestSuite = ({
  initialValues,
  onSubmit,
  open,
  handleClose,
  mode,
  error,
  isScopeDefined,
  isPlatformsDefined,
  projectId,
}) => {
  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required('Test suite name is required.')
      .test(
        'has-letter',
        'Test suite name must contain at least one letter.',
        (value) => /[a-zA-Z]/.test(value)
      )
      .test(
        'valid-characters',
        'Test suite name can only include letters, numbers, spaces, or hyphens (-).',
        (value) => /^[a-zA-Z0-9\s-]*$/.test(value)
      )
      .min(1, 'Test suite name must be at least 1 character long.'),
    description: Yup.string(),
  });
  return (
    <Modal
      open={open}
      modalTitle={mode === 'add' ? 'Add Test Suite' : 'Edit Test Suite'}
      handleClose={handleClose}>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}>
        {({ errors, touched, handleSubmit, values, setFieldValue }) => {
          const handleChange = (field, value) => {
            setFieldValue(field, value);
          };

          return (
            <Form noValidate onSubmit={handleSubmit}>
              {!isPlatformsDefined && <ExecutionScopeAlert projectId={projectId} />}
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Stack spacing={1}>
                    <InputLabel className="required">Name</InputLabel>
                    <TextInput
                      id="name"
                      required
                      value={values.name}
                      onChange={handleChange}
                      placeholder="Enter Test Suite Name"
                      maxLength={50}
                      error={touched.name && Boolean(errors.name)}
                      helperText={touched.name && errors.name}
                    />
                  </Stack>
                </Grid>

                <Grid item xs={12}>
                  <Stack spacing={1}>
                    <InputLabel>Description</InputLabel>
                    <TextInput
                      id="description"
                      value={values.description}
                      onChange={handleChange}
                      maxLength={255}
                      placeholder="Enter Description"
                      type="textarea"
                      rows={3}
                      error={touched.description && Boolean(errors.description)}
                      helperText={touched.description && errors.description}
                    />
                  </Stack>
                </Grid>
              </Grid>
              {isScopeDefined && (
                <>
                  <hr />
                  <ExecutionScopeForm
                    values={values}
                    setFieldValue={setFieldValue}
                  />
                </>
              )}

              {error && (
                <Alert severity="error" className="mt-3">
                  {error}
                </Alert>
              )}
              <CustomButton disabled={!values.name} />
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default AddTestSuite;
